import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

/** cellRendererParams.routeMap is a live, shared object (controllerName -> apiControllerRoute) — mutated in place by the parent once it loads, so this renderer always sees the latest map without re-registering the column. */
export interface ActivityLogEntityLinkCellRendererParams extends ICellRendererParams {
  routeMap: Record<string, string>;
}

@Component({
  selector: 'app-activity-log-entity-link-cell-renderer',
  templateUrl: './activity-log-entity-link-cell-renderer.component.html',
  styleUrls: ['./activity-log-entity-link-cell-renderer.component.sass'],
})
export class ActivityLogEntityLinkCellRendererComponent implements ICellRendererAngularComp {
  params: ActivityLogEntityLinkCellRendererParams;

  agInit(params: ActivityLogEntityLinkCellRendererParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  get displayName(): string {
    const data = this.params?.data;
    return data?.entityName || `${data?.entityType || 'Entity'} #${data?.entityId ?? ''}`;
  }

  get route(): string | null {
    const data = this.params?.data;
    const apiControllerRoute = data?.controllerName ? this.params?.routeMap?.[data.controllerName] : null;
    return apiControllerRoute && data?.entityId != null ? `/${apiControllerRoute}/${data.entityId}` : null;
  }
}
